
import Toast from 'vux/src/components/toast/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

export default {
components: {
Toast,InlineLoading
},
props: {
text: {
type: String | Number,
default: ''
},
time: {
type: Number,
default: 1000
},
loading: {
type: Boolean,
default: true
}
},
methods: {
close() {
this.$emit('close')
}
},
data() {
return {

}
}
}



// WEBPACK FOOTER //
// ./src/components/el-loading-toast.vue